import React from "react";
import PropTypes from "prop-types";
import { DateRange as ReactDateRange } from "react-date-range";
import Modal from "@material-ui/core/Modal";
import TextField from "@material-ui/core/TextField";
import Fade from "@material-ui/core/Fade";
import ThemeContext from "../utils/theme";
import { useStyles } from "./Input";
import DialogContent from "@material-ui/core/DialogContent";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import FormHelperText from "@material-ui/core/FormHelperText";

const humanFormat = "dd MMM yy";

export default function DateRange({
  label,
  id,
  onChange,
  previewMode = false,
  error,
  helperText,
}) {
  const { colorPrimary, colorTextBase, spacingXl } = React.useContext(ThemeContext);
  const classes = useStyles({ colorTextBase, spacingXl, colorPrimary });
  const [selection, setSelection] = React.useState({
    startDate: new Date(),
    endDate: new Date(),
    key: "selection",
    empty: true,
  });
  const [open, setOpen] = React.useState(false);
  const [humanDate, setHumanDate] = React.useState("");
  React.useEffect(() => {
    if (!open && !selection.empty) {
      const dateFns = new DateFnsUtils({ locale: esLocale });
      const startDateFns = dateFns.date(selection.startDate);
      const startDate = dateFns.format(startDateFns, humanFormat);
      const endDateFns = dateFns.date(selection.endDate);
      const endDate = dateFns.format(endDateFns, humanFormat);

      setHumanDate(`${startDate} → ${endDate}`);
    }
  }, [open, selection]);

  function handleOnRangeSelect(ranges) {
    setSelection({ ...ranges.selection, empty: false });

    if (ranges.selection.endDate !== ranges.selection.startDate) {
      setOpen(false);

      onChange({
        target: {
          name: id,
          value: {
            startDate: ranges.selection.startDate,
            endDate: ranges.selection.endDate,
          },
        },
      });
    }
  }

  return (
    <>
      <TextField
        className={classes.root}
        readOnly
        label={label}
        value={humanDate}
        onClick={() => {
          setOpen(true);
        }}
        variant="outlined"
        InputProps={{
          readOnly: true,
        }}
        error={error}
      />
      {error && <FormHelperText error={true}>{helperText}</FormHelperText>}

      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        disablePortal={previewMode}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Fade in={open} timeout={400}>
          <DialogContent style={{ display: "block", padding: 0, flex: "none" }}>
            <ReactDateRange
              rangeColors={[`rgb(${colorPrimary})`]}
              style={{ postion: "absolute", top: "50%", left: "50%" }}
              ranges={[selection]}
              onChange={handleOnRangeSelect}
            />
          </DialogContent>
        </Fade>
      </Modal>
    </>
  );
}

DateRange.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  previewMode: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
};
